module.exports = __webpack_public_path__ + "static/media/odnoklassniki.300556d8.svg";